const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';
import Save from './save';

registerBlockType('app/contact-us', {
  title: 'Fale Conosco',
  description: 'Exiba informações rápidas e diretas sobre contatos',
  icon: 'format-chat',
  category: 'design',
  attributes,
  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
